<template>
  <div>

    <d-container fluid class="main-content-container px-4" style="min-height: 700px;">

      <!-- Page Header -->
      <d-row no-gutters class="page-header py-4  pb-4 mb-3 border-bottom">
        <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
          <span class="text-uppercase page-subtitle">Spread the Word</span>
          <h3 class="page-title">Link Builder</h3>
        </d-col>
      </d-row>
        <d-row>
          <d-col lg="8" class="mb-4">
            <d-card class="card-small mb-4">

            <d-card-header class="border-bottom">
              <h6 class="m-0">Select your options below</h6>
            </d-card-header>

            <d-list-group flush>
              <d-list-group-item class="p-3">
                <d-row>
                  <d-col sm="12" md="12">
                    <d-form validated>
                      <div class="form-group" style="width:100%;">
                        <strong class="text-muted d-block mb-3">Add Your Website</strong>
                        <p class="explainer"> Must use 'https://' for security. </p>
                        <d-input style="background-image:none;" v-model="orgWebsite" placeholder="https://www.yourorganization.com"/>
                      </div>
                    </d-form>
                <div v-if="orgWebsite">
                  <strong class="text-muted d-block mb-3">Item to Share</strong>
                  <d-button-group class="mb-3">
                    <d-button type="button" class="btn-white" @click="itemChange('Sign Up Prompt')" id="Sign Up Prompt">Sign Up Prompt</d-button>
                    <d-button type="button" class="btn-white" @click="itemChange('Tier Detail')" id="Tier Detail">Tier</d-button>
                    <d-button type="button" class="btn-white" @click="itemChange('Donation')" id="Donation">Donation</d-button>
                  </d-button-group>
                  <div v-if="shareType == 'Donation'">
                    <strong class="text-muted d-block mb-2">Type</strong>
                    <d-input-group>
                      <d-select v-model="donationType" class="mb-3 button-group-donation ml-0">
                        <option value="Open Amount">Open Amount</option>
                        <option value="Preselected">Preselected</option>
                      </d-select>
                    </d-input-group>

                    <div v-if="donationType =='Preselected'">
                      <strong class="text-muted d-block mb-2">Frequency</strong>
                      <d-select v-model="frequency" @input="updateLink()" class="mb-3 button-group-donation ml-0">
                        <option value="once">Once</option>
                        <option value="monthly">Monthly</option>
                      </d-select>
                      <strong class="text-muted d-block mb-2">Select Donation Amount</strong>
                      <d-input-group class="mb-3">
                        <d-select v-model="donationAmount" @input="updateLink()">
                          <option value="5">$5</option>
                          <option value="10">$10</option>
                          <option value="15">$15</option>
                          <option value="20">$20</option>
                          <option value="25">$25</option>
                          <option value="30">$30</option>
                          <option value="35">$35</option>
                          <option value="40">$40</option>
                          <option value="45">$45</option>
                          <option value="50">$50</option>
                          <option value="55">$55</option>
                          <option value="65">$65</option>
                          <option value="70">$70</option>
                          <option value="75">$75</option>
                          <option value="100">$100</option>
                          <option value="125">$125</option>
                          <option value="150">$150</option>
                          <option value="200">$200</option>
                          <option value="250">$250</option>
                          <option value="300">$300</option>
                          <option value="400">$400</option>
                          <option value="500">$500</option>
                        </d-select>
                      </d-input-group>
                    </div>
                  </div>
                  <div v-if="shareType == 'Tier Detail'">
                    <strong class="text-muted d-block mb-2">Select a Tier Level</strong>
                    <d-input-group prepend="Tiers" class="mb-3">
                      <d-select @input="updateLink()" v-model="tierID">
                        <option default="1" value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                      </d-select>
                    </d-input-group>
                  </div>
                      <d-form v-if="!showFinal">
                        <div class="form-group" style="width:100%;">
                          <d-input placeholder="Select an item to share to generate the link" id="finalLinkToCopy"/>
                        </div>
                      </d-form>
                      <d-form v-if="showFinal" validated>
                        <div class="form-group" style="width:100%;">
                          <d-input placeholder="Select an item to share to generate the link" :value="finalLink" id="finalLinkToCopy"/>
                        </div>
                      </d-form>

                       <a :href="finalLink" target="_blank"><d-button size="sm" class="btn-white ml-auto mt-2 mr-2"><i class="material-icons">tab</i>Try Link  </d-button></a>

                      <d-button size="sm" @click="copy()" class="btn-accent ml-auto mt-2">
                        <i class="material-icons">file_copy</i> Copy to Clipboard
                      </d-button>
                </div>
                  </d-col>
                </d-row>
              </d-list-group-item>
            </d-list-group>
          </d-card>
        </d-col>
        <!--d-col lg="4" class="mb-4">
          <d-card class="card-small mb-3">
            <d-card-header class="border-bottom">
              <h6 class="m-0">Link Help</h6>
            </d-card-header>

            <d-card-body class="p-0">
                <p style="padding:15px; padding-bottom:0px;margin-bottom:10px;">There are 3 ways to share the Givemagic experience. </p>
            </d-card-body>
          </d-card>
        </d-col>-->

      </d-col>
      </d-row>
    </d-container>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  data() {
    return {
      shareType: 'Sign Up Prompt',
      orgWebsite: '',
      tierID: '1',
      finalLink: '',
      donationAmount: '',
      frequency: 'Once',
      donationType: 'Open Amount',
      showFinal: false,
    }
  },
  methods: {
    itemChange(type) {
      var prevItem = this.shareType;
      document.getElementById(prevItem).classList.add("btn-white");
      document.getElementById(prevItem).classList.remove("btn-primary");
      var newType = type;
      document.getElementById(newType).classList.add("btn-primary");
      document.getElementById(newType).classList.remove("btn-white");
      this.shareType = newType;
      this.showFinal = true;
      this.updateLink();
    },
    updateLink(){
      if (this.shareType == 'Sign Up Prompt') {
        this.finalLink = this.orgWebsite + '?gmopen=true';
      }
      if (this.shareType == 'Tier Detail') {
        this.finalLink =  this.orgWebsite + '?gmopen=true' + '&id=tier' + '&tierid=' + this.tierID;
      }
      if (this.shareType == 'Donation') {
        this.finalLink =  this.orgWebsite + '?gmopen=true' + '&id=donate' + '&amount=' + this.donationAmount +
        '&frequency=' + this.frequency ;
      }
    },
    copy(){
      var copyText = document.getElementById("finalLinkToCopy");
      copyText.select();
      document.execCommand("copy");
    }
  },

};

</script>

<style>
.was-validated .form-control:valid, .form-control.is-valid {
    border-color: #28a745;
    padding-right: calc(1.5em + 0.75rem);
    background-image: url("data:image/svg+xml,%0A%3Csvg width='84px' height='28px' viewBox='0 0 84 28' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='noun_link_1702751' transform='translate(0.000000, -1.000000)' fill='%23000000' fill-rule='nonzero'%3E%3Cg id='Group' transform='translate(0.000000, 0.637820)'%3E%3Cpath d='M14,28.3622 C6.27859,28.3622 -2.00000001e-07,22.0836 -2.00000001e-07,14.3622 C-2.00000001e-07,6.64078 6.27859,0.36219 14,0.36219 L34,0.36219 C41.72141,0.36219 48,6.64078 48,14.3622 C48.0102006,15.0834718 47.6312494,15.7543627 47.0082543,16.1179754 C46.3852592,16.4815882 45.6147408,16.4815882 44.9917457,16.1179754 C44.3687506,15.7543627 43.9897994,15.0834718 44,14.3622 C44,8.7876 39.57459,4.36219 34,4.36219 L14,4.36219 C8.42541,4.36219 4,8.7876 4,14.3622 C4,19.9368 8.42541,24.3622 14,24.3622 L34,24.3622 C34.7212718,24.3519994 35.3921627,24.7309506 35.7557754,25.3539457 C36.1193882,25.9769408 36.1193882,26.7474592 35.7557754,27.3704543 C35.3921627,27.9934494 34.7212718,28.3724006 34,28.3622 L14,28.3622 Z M50,28.3622 C42.27859,28.3622 36,22.0836 36,14.3622 C35.9897994,13.6409282 36.3687506,12.9700373 36.9917457,12.6064246 C37.6147408,12.2428118 38.3852592,12.2428118 39.0082543,12.6064246 C39.6312494,12.9700373 40.0102006,13.6409282 40,14.3622 C40,19.9368 44.42541,24.3622 50,24.3622 L70,24.3622 C75.57459,24.3622 80,19.9368 80,14.3622 C80,8.7876 75.57459,4.36219 70,4.36219 L50,4.36219 C49.2787282,4.37239058 48.6078373,3.99343941 48.2442246,3.3704443 C47.8806118,2.74744919 47.8806118,1.97693081 48.2442246,1.3539357 C48.6078373,0.730940592 49.2787282,0.351989421 50,0.36219 L70,0.36219 C77.72141,0.36219 84,6.64078 84,14.3622 C84,22.0836 77.72141,28.3622 70,28.3622 L50,28.3622 L50,28.3622 Z' id='Shape'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");

}

</style>
